<div class="esf-form-item"
     app-form-field-search
     [placeholder]="flTranslations.i18nSearchTickets"
     [id]="'search'"
     [control]="options.get('searchBy')"
     (inputChanged)="triggerSearch()">
</div>

<app-paginated-table [columns]="columns"
                     [keys]="keys"
                     [data]="invoiceList"
                     (rowClickEvent)="openInvoice($event)"

                     [baseApi]="baseApi"
                     [customQueries]="customQueries"
                     (dataFetchedEmitter)="setNewInvoiceList($event)"

                     [emptyStateText]="tablesTranslations.i18nNoCancellations"
                     [emptyStateIcon]="'#esf-icon-ticket'">

</app-paginated-table>

